// EmailVerification.jsx

import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../authContext';

const EmailVerification = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { user, setUser } = useAuth();
  const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:5001/api';

  useEffect(() => {
    const verifyEmail = async () => {
      const params = new URLSearchParams(location.search);
      const token = params.get('token');

      try {
        await axios.get(`${apiUrl}/users/verify-email?token=${encodeURIComponent(token)}`);
        if (user && !user.isVerified) {
          setUser({ ...user, isVerified: true });
        }
        alert(t('email_verified_success')); // ✅ Mostra alerta
      } catch (error) {
        console.error('Verification error:', error);
        alert(t('email_verification_failed')); // ❌ Mostra alerta d’error
      } finally {
        navigate('/'); // ✅ Torna a l'inici o on convingui
      }
    };

    verifyEmail();
  }, [location, apiUrl, user, setUser, t, navigate]);

  return null;
};

export default EmailVerification;
